export default __webpack_public_path__ + "static/media/edit-icon.5ef28948.svg";